
import state from './../state';
import SimpleEvent from './../event';

let sizeWatcherInstance = null;
class sizeWatcher{
    constructor(){
        
        this.timerId = null;
        this.event = new SimpleEvent(window, 'resize', [this, this.onResize]);
        this.setSize();
    }

    onResize(event){
        clearTimeout(this.timerId);
        this.timerId = setTimeout(this.setSize, 500);
    }

    // becarefull not to rely on scope (THIS) in this method
    setSize(){ 

        let w = window.innerWidth || 1200;
        let h = window.innerHeight || 800;
        let curSize = state.get('windowSize');
        if(! curSize || ! curSize.width || w != curSize.width){
            state.set('windowSize.width', w);
        }
        if(! curSize || ! curSize.height || h != curSize.height){
            state.set('windowSize.height', h);
        }
    }

    remove(){
        clearTimeout(this.timerId);
        this.event.remove();
        sizeWatcherInstance = null;
    }
}

export let getSizeWatcher = function(){
    if(! sizeWatcherInstance){
        sizeWatcherInstance = new sizeWatcher();
    }
    return sizeWatcherInstance;
}